import RegisterConfirmation from './RegisterConfirmation';

export default RegisterConfirmation;
